export const productColumnData = [
  {
    field: "title",
    title: "TITLE",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 15,
  },
  {
    field: "barcodeValue",
    title: "ITEM_BARCODE_VALUE",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 12,
  },
  {
    field: "stockCode",
    title: "SKU",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 10,
  },
]
